import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

class Timer extends Component {
  static propTypes = {
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.instanceOf(Date)])
      .isRequired,
    offset: PropTypes.number,
    onEnd: PropTypes.func,
  };

  static defaultProps = {
    offset: 0,
    onEnd: undefined,
  };

  constructor(props) {
    super(props);
    this.state = {
      from: moment().subtract(props.offset, 'milliseconds'),
      interval: null,
    };
  }

  componentDidMount() {
    const interval = setInterval(this.tick, 1000);
    this.setState({ interval });
  }

  componentWillUnmount() {
    clearInterval(this.state.interval);
  }

  tick = () => {
    const { to, offset, onEnd } = this.props;
    const from = moment().subtract(offset, 'milliseconds');

    this.setState({ from });

    if (from.isAfter(to)) {
      clearInterval(this.state.interval);

      if (onEnd) {
        onEnd();
      }
    }
  };

  render() {
    const diff = moment.duration(Math.max(0, moment(this.props.to).diff(this.state.from)));
    const minutes = Math.floor(diff.asMinutes());
    const seconds = diff.seconds();

    return (
      <span>
        {`${minutes}`.padStart(2, '0')}:{`${seconds}`.padStart(2, '0')}
      </span>
    );
  }
}

export default Timer;



// WEBPACK FOOTER //
// ./src/site-render/src/Timer/Timer.js